import { IS_LOADING_RECOMENDPROD_HOME } from "../../ActionType/actionTypes";

export function isLoadingRecomendProdHome(param) {
    return (dispatch) => {
        dispatch({
            type: IS_LOADING_RECOMENDPROD_HOME, 
            payload: {
                isLoadingRecomendProdHome: param
            }
        })
    }
}